const ProductCardSkeleton = () => {
  return (
    <div className="flex animate-pulse flex-col gap-2 *:bg-base-300">
      <div className="brand-product-placeholder w-full" />
      <div className="h-4 w-3/4"></div>
      <div className="h-4 w-1/2"></div>
    </div>
  );
};

export default ProductCardSkeleton;
